// Filter data constants - copied from admin-web
export const FilterList: any[] = [
    {
        id: 75,
        title: "Weekend (28 Oct-3 Nov)",
        startTime: new Date('2025-10-28 00:00:00').getTime(),
        endTime:  new Date('2025-11-04 00:00:00').getTime(),
        match: false,
    },
    {
        id: 76,
        title: "Weekend (4-10 Nov)",
        startTime: new Date('2025-11-04 00:00:00').getTime(),
        endTime: new Date('2025-11-10 23:59:00').getTime(),
        match: false,
    },
    {
        id: 77,
        title: "Weekend (11-17 Nov)",
        startTime: new Date('2025-11-11 00:00:00').getTime(),
        endTime: new Date('2025-11-17 23:59:00').getTime(),
        match: false,
    },
    {
        id: 78,
        title: "Weekend (18-24 Nov)",
        startTime: new Date('2025-11-18 00:00:00').getTime(),
        endTime: new Date('2025-11-24 23:59:00').getTime(),
        match: false,
    },
    {
        id: 79,
        title: "Weekend (25 Nov-1 Dec)",
        startTime: new Date('2025-11-25 00:00:00').getTime(),
        endTime: new Date('2025-12-01 23:59:00').getTime(),
        match: false,
    },
    {
        id: 80,
        title: "Weekend (2-8 Dec)",
        startTime: new Date('2025-12-02 00:00:00').getTime(),
        endTime: new Date('2025-12-08 23:59:00').getTime(),
        match: false,
    },
    {
        id: 81,
        title: "Weekend (9-15 Dec)",
        startTime: new Date('2025-12-09 00:00:00').getTime(),
        endTime: new Date('2025-12-15 23:59:00').getTime(),
        match: false,
    },
    {
        id: 1,
        title: "YEAR 2023(JAN - JUN)",
        startTime: new Date('2023-01-01 00:00:00').getTime(),
        endTime: new Date('2023-06-30 23:59:00').getTime(),
        match: false,
    },
    {
        id: 2,
        title: "YEAR 2023(JULY - DEC)",
        startTime: new Date('2023-07-01 00:00:00').getTime(),
        endTime: new Date('2023-12-31 23:59:00').getTime(),
        match: false,
    },
    {
        id: 3,
        title: "YEAR 2024(JAN - JUN)",
        startTime: new Date('2024-01-01 00:00:00').getTime(),
        endTime: new Date('2024-06-30 23:59:00').getTime(),
        match: false,
    },
    {
        id: 4,
        title: "YEAR 2024(JULY - DEC)",
        startTime: new Date('2024-07-01 00:00:00').getTime(),
        endTime: new Date('2024-12-31 23:59:00').getTime(),
        match: false,
    },
    {
        id: 5,
        title: "YEAR 2025(JAN - JUN)",
        startTime: new Date('2025-01-01 00:00:00').getTime(),
        endTime: new Date('2025-06-30 23:59:00').getTime(),
        match: false,
    },
    {
        id: 6,
        title: "YEAR 2025(JULY - SEP)",
        startTime: new Date('2025-07-01 00:00:00').getTime(),
        endTime: new Date('2025-9-30 23:59:00').getTime(),
        match: false,
    },
    {
        id: 7,
        title: "OCT 2025",
        startTime: new Date('2025-10-01 00:00:00').getTime(),
        endTime: new Date('2025-10-29 23:59:00').getTime(),
        match: false,
    }
];

export default FilterList;
